import {StyleSheet} from 'react-native';

import {MAX_CONTENT_WIDTH} from '/constant/data.constant';
import {indent} from '/constant/layout.constant';
import {white} from '/theme/color/on.color';
import {alto, mineShaft} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  navigationContainer: {
    marginBottom: -indent * 0.5,
  },
  title: {
    marginRight: indent * 0.7,
    color: mineShaft,
  },
  contentContainer: {
    paddingHorizontal: indent * 1.2,
  },
  separator: {
    height: 1,
    minHeight: 1,
    backgroundColor: alto,
    marginTop: indent * 1.2,
    marginBottom: indent * 0.8,
    alignSelf: 'stretch',
  },
  icon: {
    color: mineShaft,
    width: 14,
  },
  base: {
    backgroundColor: white,
    width: '100%' as const,
    maxWidth: MAX_CONTENT_WIDTH as number,
    alignSelf: 'center' as const,
  },
});
